'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export default function CheckPage() {
  const router = useRouter();

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (event.origin !== 'https://tally.so') return;
      let data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }
      if ((data as { event?: string })?.event === 'Tally.FormSubmitted') {
        if (window.fbq) {
          window.fbq('track', 'Lead');
        }
        router.push('/thankyou');
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <>
      <style>{`
        .tally-wrapper {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          height: 100dvh;
          overflow: hidden;
          -webkit-overflow-scrolling: touch;
        }
        .tally-iframe {
          display: block;
          width: 100%;
          height: 100%;
          border: none;
          margin: 0;
          padding: 0;
        }
      `}</style>
      <div className="tally-wrapper">
        <iframe
          src="https://tally.so/r/VLOJ7M"
          title="Fire Claims Check formulier"
          className="tally-iframe"
          allowFullScreen
        />
      </div>
    </>
  );
}
